const Env = {
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,

  CLIENT_ID: import.meta.env.VITE_CLIENT_ID as string,
  TENANT_ID: import.meta.env.VITE_TENANT_ID as string,
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI as string,
  MICROSOFT_LOGIN_URL: import.meta.env.VITE_MICROSOFT_LOGIN_URL as string,
  MICROSOFT_GRAPH_ME_ENDPOINT: import.meta.env.VITE_MICROSOFT_GRAPH_ME_ENDPOINT as string,
  API_SCOPE_ADMIN: import.meta.env.VITE_API_SCOPE_ADMIN as string,
  API_SCOPE_READWRITE: import.meta.env.VITE_API_SCOPE_READWRITE as string,
  API_SCOPE_READ: import.meta.env.VITE_API_SCOPE_READ as string,
  API_URL: import.meta.env.VITE_API_URL as string,
  CHAINLIT_HISTORY_SIZE: import.meta.env.VITE_CHAINLIT_HISTORY_SIZE as number,
  CHAINLIT_URL: import.meta.env.VITE_CHAINLIT_URL as string,
  CHAINLIT_PROVIDER: import.meta.env.VITE_CHAINLIT_PROVIDER as string,
};
export default Env;
